import CardResultados from "./../../CardResultados";
import colors from "core/resources/theme/colors";
import { FaUsers } from "react-icons/fa";
import { MdHowToVote } from "react-icons/md";
import { VotacaoPerguntaEstatisticaDetalhesDto } from "core/features/assembleia/typings";

interface ResultadoPerguntaParticipantesPesoProps {
  data?: VotacaoPerguntaEstatisticaDetalhesDto;
  isLoading?: boolean;
}

function ResultadoPerguntaParticipantesPeso({
  data,
  isLoading,
}: ResultadoPerguntaParticipantesPesoProps) {
  return (
    <>
      <CardResultados
        isLoading={isLoading}
        bg={colors.blue100}
        name="Unidades participantes"
        icon={<FaUsers fontSize="24px" color={colors.purple} />}
        complete={false}
        value={`${data?.participantes || "--"}`}
      />

      <CardResultados
        isLoading={isLoading}
        bg={colors.blue100}
        name="Votos com peso"
        icon={<MdHowToVote fontSize="24px" color={colors.blue} />}
        complete={false}
        value={`${data?.totalPesos || "--"}`}
      />
    </>
  );
}

export default ResultadoPerguntaParticipantesPeso;
